import { Value } from "@sinclair/typebox/value";
import { GetEntitiesResponse, GetEntityByIdResponseSchema } from "../../packages/appstore-openapi-spec/bundle/v2";

export async function getEntityById(id: string, token: string) {
  const res = await fetch(
    `${import.meta.env.ZUDOKU_PUBLIC_API_URL}/entities/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!res.ok) {
    throw new Error("Failed to fetch entity");
  }

  return Value.Cast(GetEntityByIdResponseSchema, await res.json());
}

export async function getEntities(
  accessToken: string
): Promise<GetEntitiesResponse> {
  const response = await fetch(
    `${import.meta.env.ZUDOKU_PUBLIC_API_URL}/entities`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error(
      `Failed to fetch entities: ${response.status} ${response.statusText}`
    );
  }

  const result = await response.json();
  // TODO: fix this
  // Value.Assert(GetEntitiesResponseSchema, result);
  return result;
}
